import { ITax } from './Tax';
export class GlobalSettings {
    StoreTaxRate: ITax;
    CurrentDate: Date;
}